import AlarmContainer from "./AlarmContainer";

export default AlarmContainer;
